import { AnalogDut, AnalogInput, AnalogOutput, AnalogTemperatureSensor, BoilerAdapter, BoilerCascade, BoilerGroup, Buzzer, CalibrationTable, Command, Comparator, ConditionalOperator, DayTimetable, DigitalDut, Fob, FobButton, GraphPanel, GuardIndicator, GuardZone, HeatingCircuit, IntervalTimetable, IOExtension, LogicExpression, ModBusDevice, ModBusSignal, Notification, NTCTemperatureCurve, ObjectArrays, OutputAction, Pause, Pump, Pza, RadioDut, RadioModule, RadioSensor, RadioSensor433, RelayControl, Scenario, SensorReading, StopScenario, ThreewayTap, TimeComparator, TimeInterval, TMKey, translateBoilerAdapterProtocol, UIGroup, User, UserRole, WebElement, WeekTimetable, WiredTemperatureSensor, } from 'z3k-config';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
import { MQTTTopic } from 'z3k-parser/model/z3k-config/57-mqtt';
const _object_namespace_by_type = new Map([
    ['analog_inputs', AnalogInput], //0
    ['wired_temperature_sensors', WiredTemperatureSensor],
    ['guard_zones', GuardZone],
    ['notifications', Notification],
    ['users', User],
    ['output_actions', OutputAction], //5
    ['boiler_adapters', BoilerAdapter],
    ['radiomodules', RadioModule],
    ['radiosensors', RadioSensor],
    ['commands', Command],
    ['web_elements', WebElement], //10
    ['scenarios', Scenario],
    ['buzzers', Buzzer],
    ['guard_indicators', GuardIndicator],
    ['relay_controls', RelayControl],
    ['threeway_taps', ThreewayTap], //15
    ['heating_circuits', HeatingCircuit],
    ['pumps', Pump],
    ['tm_keys', TMKey],
    ['user_roles', UserRole],
    ['heating_modes', HeatingMode], //20
    ['day_timetables', DayTimetable],
    ['week_timetables', WeekTimetable],
    ['io_extensions', IOExtension],
    ['pzas', Pza], //25
    ['boiler_groups', BoilerGroup],
    ['analog_temperature_sensors', AnalogTemperatureSensor],
    ['ntc_temperature_curves', NTCTemperatureCurve],
    ['fobs', Fob],
    ['fob_buttons', FobButton], //30
    ['radiosensors433', RadioSensor433],
    ['time_intervals', TimeInterval],
    ['interval_timetables', IntervalTimetable],
    ['analog_duts', AnalogDut], //35
    ['calibration_tables', CalibrationTable],
    ['digital_duts', DigitalDut],
    ['radio_duts', RadioDut],
    ['graph_panels', GraphPanel],
    ['boiler_cascades', BoilerCascade],
    ['ui_groups', UIGroup], //42
    ['object_arrays', ObjectArrays],
    ['pauses', Pause],
    ['conditional_operators', ConditionalOperator],
    ['comparators', Comparator],
    ['logic_expressions', LogicExpression],
    ['sensor_readings', SensorReading],
    ['time_comparators', TimeComparator],
    ['modbus_devices', ModBusDevice],
    ['modbus_signals', ModBusSignal],
    ['analog_outputs', AnalogOutput],
    ['stop_scenarios', StopScenario],
    ['mqtt_topics', MQTTTopic],
]);
export function getTypeNameFromZ3kType(key, value) {
    const obj_namespace = _object_namespace_by_type.get(key);
    if (obj_namespace) {
        if (key == 'boiler_adapters') {
            return translateBoilerAdapterProtocol(value) ?? `Неизвестный: ${value}`;
        }
        return (`${obj_namespace.Type?.[value]} (${value})` ??
            `${value} not found in type ${key}`);
    }
    return `${value}`;
}
export function getFlagNameFromZ3kType(key, value) {
    const obj_namespace = _object_namespace_by_type.get(key);
    if (obj_namespace) {
        return (`${obj_namespace.Flags?.[1 << value]} (${value})` ??
            `${value} not found in type ${key}`);
    }
    return `${value}`;
}
export function getStateFlagNameFromZ3kType(key, value) {
    const obj_namespace = _object_namespace_by_type.get(key);
    if (obj_namespace) {
        return (`${obj_namespace.StatusFlags?.[1 << value]} (${value})` ??
            `${value} not found in type ${key}`);
    }
    return `${value}`;
}
